import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import API_BASE from "../config/api";

export default function WebBiography() {
    const user = JSON.parse(localStorage.getItem("user"));
    const personaluid = user?.personaluid;
    const fullName = user?.fullname || "User";

    const [domain, setDomain] = useState("");
    const [biography, setBiography] = useState("");

    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1500
        });
    };

    // Load existing biography link
    useEffect(() => {
        fetch(`${API_BASE}/api/get_webbiography.php?personaluid=${personaluid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setDomain(data.domain || "");
                    setBiography(data.data?.biographylink || "");
                }
            });
    }, [personaluid]);

    const handleChange = (e) => {
        setBiography(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!biography) {
            showToast("Please enter the biography link", "warning");
            return;
        }

        const fd = new FormData();
        fd.append("personaluid", personaluid);
        fd.append("domain", domain);
        fd.append("biographylink", biography);

        fetch(`${API_BASE}/api/save_webbiography.php`, {
            method: "POST",
            body: fd
        })
            .then(res => res.json())
            .then(data => {
                showToast(data.message, data.success ? "success" : "error");
            });
    };

    return (
        <div className="container-fluid px-4 py-3">

            {/* Page Header */}
            <div
                className="rounded p-3 mb-3 shadow-sm"
                style={{
                    background: "linear-gradient(135deg, #e8f0ff, #fefefe)",
                    borderLeft: "6px solid #4a90e2"
                }}
            >
                <h5 className="fw-bold text-dark mb-1">Website - Biography</h5>
                <p className="text-secondary mb-0">
                    Update your website contents! of <b>{fullName}</b>
                </p>
            </div>

            {/* Biography Form */}
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body">

                    <form autoComplete="off" onSubmit={handleSubmit}>

                        <input type="hidden" name="domain" value={domain} />

                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <label className="form-label fw-semibold">
                                    Biography - Youtube Video Link <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="biography"
                                    className="form-control form-control-sm"
                                    placeholder="Enter Youtube video link"
                                    value={biography}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="text-end">
                            <button
                                type="submit"
                                className="btn btn-primary px-4 mt-2"
                            >
                                <i className="bi bi-cloud-upload-fill me-1"></i>
                                Update
                            </button>
                        </div>

                    </form>

                </div>
            </div>

        </div>
    );
}
